import "./ListParts.css";

/**
 * Selo de situação na grade das listagens.
 *
 * O tom diz o quanto a linha ainda pede atenção: pendente em âmbar, concluído em verde,
 * cancelado apagado e riscado para não competir com o que ainda vale. Para registros que
 * não são cobrança (eventos de integração, por exemplo): danger para falha, que precisa de
 * investigação; muted para o que foi descartado sem erro, apagado mas sem risco, porque o
 * registro continua valendo; e info para o que ainda está em andamento.
 *
 * @param {string} tone - pending, paid, canceled, danger, muted ou info.
 */
const StatusPill = ({ tone, children }) => (
    <span className={`status-pill status-pill--${tone}`}>{children}</span>
);

export default StatusPill;
